export interface IEvents {
  tabState: TabState;
  buttonDemo: ButtonDemo;
  areSettingsOpened: boolean;
  reset: undefined;
}

export const PUBLISH_EVENT_TIMEOUT = 1000;

type SettingsEventKeys = keyof IEvents;

export const SETTINGS_EVENTS = {
  ARE_SETTINGS_OPENED: 'areSettingsOpened',
  BUTTON_DEMO: 'buttonDemo',
  TAB_STATE: 'tabState',
  RESET: 'reset',
} as const satisfies Record<string, SettingsEventKeys>;

export enum TabState {
  REGULAR = 'regular',
  HIGHLIGHTED = 'highlighted',
}

export enum ButtonDemo {
  NONE = 'none',
  REGULAR_HOVER = 'regular-hover',
  HIGHLIGHTED_HOVER = 'highlighted-hover',
}
